// English translations (secondary language)

const en = {
  common: {
    appName: 'ArbiWin.bg',
    language: 'Language',
    save: 'Save',
    cancel: 'Cancel',
    close: 'Close',
    confirm: 'Confirm',
    back: 'Back',
    next: 'Next',
    submit: 'Submit',
    apply: 'Apply',
    reset: 'Reset',
    clear: 'Clear',
    yes: 'Yes',
    no: 'No',
    search: 'Search',
    loading: 'Loading...',
    required: 'Required field',
  },

  navigation: {
    home: 'Home',
    login: 'Login',
    register: 'Register',
    dashboard: 'Dashboard',
    subscription: 'Subscription',
    surebets: 'Surebets',
    about: 'About',
    contact: 'Contact',
    terms: 'Terms',
    privacy: 'Privacy',
    profile: 'Profile',
    logout: 'Logout',
    overview: 'Overview',
    pricing: 'Pricing',
    faq: 'FAQ',
    howToSubscribe: 'How to Subscribe',
    loading: 'Loading...',
    checkingAuthentication: 'Checking authentication...',
    checkingSubscription: 'Checking subscription...',
    checkingPermissions: 'Checking permissions...',
    breadcrumb: {
      ariaLabel: 'Breadcrumb navigation',
      navigateTo: 'Navigate to {page}',
      home: 'Home',
    },
  },

  landing: {
    hero: {
      title: 'Mathematical edge through dynamic data analysis',
      subtitle: 'ArbiWin.bg is an intelligent sports data terminal. Discover arbitrage situations (risk-free mathematical models) and detect market anomalies (the highest values on the market) across 23 licensed operators in Bulgaria. All in real time — on your screen or in Telegram.',
      getStarted: 'Start 3-day free trial',
    },
    heroToggle: {
      ariaLabel: 'Switch between platform products',
      arbitrage: '⚖️ ARBITRAGE SITUATIONS',
      bestOdds: '🚀 MARKET ANOMALIES (Best Odds)',
    },
    previews: {
      title: 'Market Arbitrage Previews',
      description: 'A real-time glimpse of market inefficiencies identified by our algorithm. Sensitive data is masked for non-subscribers.',
      tableProfit: 'Margin',
      tableEvent: 'Event',
      tableMarket: 'Market',
      tableBookmakers: 'Bookmakers',
      bookmakerCount: 'Bookmakers',
      unlock: 'Unlock',
      market1X2: 'Match Outcome (1X2)',
      marketOverUnder: 'Total Points (Over/Under)',
      marketWinner: 'Winner',
      marketHandicap: 'Asian Handicap',
    },
    pricing: {
      title: 'ArbiWin Premium: Full analytical access',
      description: '',
      planTitle: 'ArbiWin Premium',
      period: '(per month)',
      featuresIncludes: 'What\'s included:',
      feature1: '✅ Arbitrage module: Unlimited access to all arbitrage situations',
      feature2: '✅ Market Anomalies module: Radar for highest values vs market averages (Tier 1 leagues only)',
      feature3: '✅ Telegram alerts: Automatic notifications when favourable positions are detected',
      feature4: '✅ Integrated calculator: Capital optimization for arbitrage',
      feature5: '✅ Dynamic data refresh from 23 operators',
      cta: 'Start 3-day free trial',
      promoText: '🎁 3-Day Free Trial (New subscribers only)',
      promoDisclaimer: '(Billing starts after day 3. No commitment — cancel whenever you decide).',
    },
    cta: {
      title: 'Master the market efficiency with ArbiWin.bg',
      button: 'Create Account',
    },
    testimonials: {
      title: 'Users Feedback',
      subtitle: 'Join users who utilize data to make smarter decisions',
      testimonial1: {
        quote: 'ArbiWin.bg changed my approach. Instead of guessing, I now follow a strict mathematical strategy.',
        name: 'Ivan Petrov',
        role: 'Member for 6 months'
      },
      testimonial2: {
        quote: 'The platform is intuitive and very easy to use. A must-have tool.',
        name: 'Maria Georgieva',
        role: 'Member for 1 month'
      },
      testimonial3: {
        quote: 'Excellent ROI on the subscription. The calculator feature saves me time and minimizes errors.',
        name: 'Dimitar Stoyanov',
        role: 'Member for 2 months'
      },
      trust: {
        users: '500+',
        usersLabel: 'Active Users',
        surebets: '10,000+',
        surebetsLabel: 'Opportunities Found',
        satisfaction: '98%',
        satisfactionLabel: 'Retention Rate'
      }
    },
    maskedPreview: {
      title: 'Simulation of detected mathematical discrepancies',
      subtitle: 'Take advantage of value differences between different operators.',
      totalLabel: 'Active opportunities',
      profitableLabel: 'High-margin opportunities',
      shownLabel: 'Shown (top by margin)',
      loading: 'Loading market data...',
      error: 'Error loading data',
      empty: 'No opportunities matching criteria',
      activateButton: 'Activate subscription',
      unlockButton: 'Unlock details',
      eventColumn: 'Event',
      marketColumn: 'Market',
      oddsColumn: 'Coefficients',
      profitColumn: 'Margin',
      actionColumn: 'Action',
    },
    liveDemo: {
      title: 'LIVE DEMO: Current opportunity right now',
      footerLink: 'See all other arbitrage opportunities – Subscribe now',
      bookmakerLabel: 'Bookmaker',
      marginInfoAriaLabel: 'Live Demo margin information',
      marginInfoTooltip:
        'This signal is part of our Live Demo. The data is provided for illustrative purposes and reflects the real functionality of the platform. For full access to all analyses, activate a Premium subscription.',
    },
    bestOddsPreview: {
      title: 'Market anomalies radar (Top Leagues)',
      subtitle: 'The algorithm scans elite leagues (Tier 1) and alerts you when an operator offers a value significantly above the market average.',
      totalLabel: 'Active anomalies',
      shownLabel: 'Shown (top by deviation)',
      loading: 'Loading market data...',
      error: 'Error loading data',
      empty: 'No market anomalies detected at the moment',
      activateButton: 'Activate subscription',
      unlockButton: 'Unlock details',
      unlockAllButton: 'Unlock all',
      newBestOddsBadge: '🚨 NEW MARKET ANOMALY',
      eventLabel: 'Event',
      marketLabel: 'Market',
      outcomeLabel: 'Outcome',
      maxValueLabel: 'Maximum value',
      marketAvgLabel: 'Market average',
      spreadLabel: 'Deviation (Spread)',
      bookmakerHiddenLabel: 'Hidden bookmaker',
      eventHiddenLabel: 'Hidden event',
    },
    bestOddsLiveDemo: {
      title: 'LIVE DEMO: Current market anomaly',
      footerLink: 'Unlock all',
      badge: 'LIVE DEMO',
    },
    telegramPromo: {
      title: '🚀 NEW: Your personal algorithm is now on Telegram',
      subtitle: 'Stop wasting time in front of the screen. Set your filters and let ArbiWin work for you 24/7.',
      feature1: {
        title: '🎯 Personalized margin',
        description: 'Set your minimum (e.g. above 3%) and get an alert only when it is worth it.',
      },
      feature2: {
        title: '🛡️ Smart Anti-Spam',
        description: 'Built-in 4-hour protection against duplicate signals for the same match.',
      },
      feature3: {
        title: '🔕 Quiet hours',
        description: 'Enable "Sleep" mode (00:00 – 08:00) so you are not disturbed at night.',
      },
      cta: 'Start 3-day free trial',
    },
    academyPromo: {
      title: '🎓 ArbiWin Academy: Learn from real market data',
      intro1: 'Want to see how our algorithm works in action?',
      intro2: 'Follow our official YouTube channel @ArbiWin-SportsAnalytics.',
      introLead: 'There we regularly publish:',
      feature1: '✔️ Case Studies: Breakdowns of real arbitrage situations and market anomalies detected by the software.',
      feature2: '✔️ Guides: How to use filters, the calculator, and smart Telegram alerts for maximum efficiency.',
      feature3: '✔️ Mathematical strategies: Explanation of the logic behind odds movements at licensed operators.',
      cta: 'Subscribe on YouTube',
      disclaimer: '*Important: All unmasked data, operator names, and odds shown in the video materials are historical (archived) and serve exclusively educational and illustrative purposes. ArbiWin.bg does not provide gambling advice. An active subscription is required for real-time monitoring.',
    },
    educational: {
      expand: 'Read more',
      collapse: 'Close',
      whatIsSurebet: {
        title: 'What is Sports Arbitrage?',
        intro: 'Our algorithm detects discrepancies that allow you to cover all outcomes of an event.',
        visual: {
          title: 'Arbitrage Mechanism Example',
          bookmaker1: 'Operator A',
          bookmaker2: 'Operator B',
          outcome1: 'Outcome 1',
          outcome2: 'Outcome 2',
          profit: 'Positive Margin'
        },
        point1: {
          title: 'Mathematical Strategy',
          description: 'By covering all outcomes, the strategy relies on mathematics rather than prediction or luck.'
        },
        point2: {
          title: 'Leveraging Inefficiencies',
          description: 'Operators often price events differently. We identify these gaps.'
        },
        point3: {
          title: 'Smart Calculation',
          description: 'Our tools calculate the exact distribution needed to secure a balanced position.'
        },
        example: {
          title: 'The Math Explained',
          scenario: 'Example: Event with a 2.5% arbitrage margin using 1000 units.',
          step1: 'Allocation: 490 units on Outcome 1 (Coef. 2.10)',
          step2: 'Allocation: 510 units on Outcome 2 (Coef. 2.15)',
          step3: 'Result: 1025 units returned regardless of the match winner.',
          result: 'Net positive result'
        }
      },
      whatIsMarketAnomaly: {
        title: 'What is a Market Anomaly?',
        intro: 'While sports arbitrage relies on covering all possible outcomes of an event for guaranteed returns, a Market Anomaly (Value Betting / Best Odds) is a strategy focused on finding a mathematical mispricing in the assessment of a single specific outcome.',
        algorithm: {
          title: 'How does the ArbiWin algorithm work?',
          scan: 'Our system continuously scans and averages the values offered by all 23 licensed operators in Bulgaria for a given outcome (for example: Home Win).',
          detection: 'When the algorithm detects that one operator offers a coefficient that deviates significantly (for example by 10% or more) above the average market value (Market Average), the system marks this as an Anomaly.',
        },
        example: {
          title: 'Practical example:',
          marketAverage: 'Average market coefficient for "Arsenal Win":',
          marketAverageValue: '2.04',
          operatorCoefficient: 'Coefficient at Operator A:',
          operatorCoefficientValue: '2.12',
          spread: 'Deviation (Spread):',
          spreadValue: '+3.92%',
          conclusion: 'This means Operator A has undervalued the event or delayed updating its data. Using such "anomalies" gives the informed user a long-term mathematical edge (Expected Value) over the market.',
        },
        warning: {
          label: 'Important:',
          text: 'Unlike arbitrage, market anomalies do not cover all outcomes. The result of each individual event remains unknown, but the systematic use of such elevated values is at the core of professional statistical analysis.',
        },
      },
      bookmakerLimitations: {
        title: 'Account Health & Best Practices',
        intro: 'To maintain healthy accounts while trading sports markets, consider these practices:',
        tip1: {
          title: 'Diversify Platforms',
          description: 'Spread your activity across multiple licensed operators.'
        },
        tip2: {
          title: 'Round Numbers',
          description: 'Use round numbers to mimic recreational behavior (e.g., 50 instead of 49.32).'
        },
        tip3: {
          title: 'Mixed Strategy',
          description: 'Don\'t rely solely on arbitrage. A natural profile includes various activity types.'
        },
        tip4: {
          title: 'Use ArbiWin Intelligence',
          description: 'We aggregate data from many sources to help you spread your volume.'
        },
        strategy: {
          title: 'Sustainability Strategy',
          step1: {
            title: 'Multiple Registrations',
            description: 'Having accounts with all major Bulgarian licensed operators is essential for arbitrage.'
          },
          step2: {
            title: 'Activity Blending',
            description: 'Use our platform to find opportunities that don\'t look suspicious.'
          },
          step3: {
            title: 'Stay Natural',
            description: 'Avoid patterns typical of bots or aggressive traders to prolong account life.'
          }
        }
      },
      whyUnique: {
        title: 'Why ArbiWin.bg?',
        intro: 'Specialized analytics for the Bulgarian market offering distinct advantages:',
        feature1: {
          title: '100% Bulgarian Focus',
          description: 'We monitor only licensed Bulgarian operators, ensuring relevance and safety for local users.'
        },
        feature2: {
          title: 'Data Feed',
          description: 'Periodic data updates to capture market opportunities.'
        },
        feature3: {
          title: 'Integrated Calculator',
          description: 'Instantly calculates the optimal numbers distribution for any given margin.'
        },
        feature4: {
          title: 'Smart Filters',
          description: 'Filter by ROI, specific operator, sport, and time to start.'
        },
        feature5: {
          title: '🤖 Full Telegram Automation:',
          description: 'Unlike standard platforms that require you to spend hours in front of the screen refreshing manually, ArbiWin works as your personal assistant. You set your minimum margin parameters, and the software sends you an instant Telegram alert the moment it detects a market inefficiency. You invest time only when there is a real opportunity to act.'
        },
        feature6: {
          title: '🧠 Artificial Intelligence vs Spam (Zero-Spam Logic)',
          description: 'Our Telegram bot does not flood you with meaningless messages. Our Market Anomalies algorithm uses a global filter – you receive an alert only when the value truly improves (reaches a new market peak). If the market is stagnant, your phone stays quiet and you keep your focus.'
        },
        comparison: {
          title: 'Platform Comparison',
          other: {
            title: 'Generic Platforms',
            point1: 'Cluttered with irrelevant intl. operators',
            point2: 'Expensive subscriptions',
            point3: 'Complex for beginners'
          },
          our: {
            title: 'ArbiWin.bg',
            point1: 'Tailored for Bulgaria',
            point2: 'Supports only licensed operators',
            point3: 'Notifications above a set margin threshold'
          }
        }
      },
      bestOddsFaq: {
        title: 'Arbitrage situations vs Market anomalies',
        q1: {
          question: 'What is the difference between Arbitrage situations and Market anomalies (Best Odds)?',
          answer: 'Arbitrage is a mathematical situation where, by covering all possible outcomes of an event across different operators, you secure an expected return regardless of the final result. Market anomalies (Best Odds) show single values (coefficients) for a specific outcome that our algorithm has identified as significantly higher than the averages at other operators. With market anomalies, you choose to analyse only one specific outcome.',
        },
        q2: {
          question: 'Why do I only see matches from major leagues in "Market anomalies"?',
          answer: 'The market anomalies module is configured to scan only so-called Tier 1 leagues (elite European tournaments such as the Champions League, English Premier League, La Liga, etc.). This ensures high liquidity at operators and minimizes the risk of technical errors in coefficient pricing (so-called "palms") that are common in lower divisions.',
        },
      },
      telegramNotifications: {
        title: 'Telegram Alerts and Settings',
        q1: {
          question: 'How do I connect and activate my Telegram bot?',
          intro: 'Activation takes exactly 10 seconds:',
          step1: 'Log in to your ArbiWin.bg account and open the „Profile“ section.',
          step2: 'In the „Notification Center“ panel, click the „Connect Telegram“ button.',
          step3: 'Telegram will open. Press START and the bot will confirm the connection instantly! (The service is free and available to all users with an active Premium subscription or 3-day trial period).',
        },
        q2: {
          question: 'Why do I see arbitrage or an anomaly on the site but did not receive a Telegram alert?',
          intro: 'Our algorithm uses multi-layer spam protection to send you only the most important information. You may not have received an alert for one of the following reasons:',
          reason1: 'Your personal filter: The event percentage (margin or deviation) is lower than the threshold you set in settings.',
          reason2: 'Quiet hours mode: Your alerts are paused between 00:00–08:00.',
          reason3: 'The "New Peak" rule (Market anomalies only): Our system sends an alert only when the coefficient rises and marks a new highest market value. If the operator keeps the same high coefficient for hours or slightly lowers it, you will still see it on the site, but the bot will not spam you again for it.',
          reason4: 'Smart Anti-Spam (4 hours): You already received a signal for this specific event (for arbitrage) or for this specific outcome (for anomalies) in the last 4 hours. The system temporarily mutes repeat signals so you can focus on new opportunities.',
        },
      },
      interactiveExamples: {
        title: 'Scenarios',
        intro: 'Practical examples of how margins work:',
        scenario1: {
          title: 'Case Study: Small Volume',
          description: 'Total volume 100 units with 2.5% margin.',
          calc1: 'Volume: 100',
          calc2: 'Returns: 102.50',
          calc3: 'Net: +2.50'
        },
        scenario2: {
          title: 'Case Study: Higher Volume',
          description: 'Total volume 500 units with 2.5% margin.',
          calc1: 'Volume: 500',
          calc2: 'Returns: 512.50',
          calc3: 'Net: +12.50'
        },
        cta: 'Join to see more'
      }
    },
  },

  dashboard: {
    tabs: {
      arbitrage: '📊 Arbitrage Analysis',
      bestOdds: '🔥 Market Anomalies',
      nearArb: 'Near-arb',
      notifications: '🔔 Alerts (Telegram)',
    },
    productInfo: {
      arbitrage: 'This module provides classic arbitrage analysis with positive margin. Signals are sorted by highest margin.',
      bestOdds: 'This module scans elite tournaments (Tier 1). Cards appear dynamically when the algorithm detects a deviation (Spread) above the set threshold compared to the average market value.',
      nearArb: 'Shows events above the configured threshold for the selected bookmakers, including positive margin. A value of 0% or below is not a surebet. Odds at the outlets differ from those on the bookmakers\' online sites.',
    },
  },

  nearArb: {
    infoLine: 'Bookmakers: {bookmakers}. Threshold: above {minMargin}%',
    upgradeRequired: 'Ultimate subscription required',
    unavailable: 'Near-arb is not available',
  },

  admin: {
    activity: {
      title: 'Product activity',
      subtitle: 'Internal platform usage statistics (Super Admin only).',
      from: 'From',
      to: 'To',
      refresh: 'Refresh',
      loading: 'Loading...',
      rangeHint: 'Maximum range: {max} days. No automatic refresh.',
      totalsTitle: 'Totals by action',
      byDayTitle: 'By day',
      empty: 'No data for the selected period.',
      columns: {
        action: 'Action',
        count: 'Count',
        uniqueUsers: 'Unique users',
        date: 'Date'
      },
      errors: {
        forbidden: 'You do not have permission to view this statistics.',
        unauthorized: 'Your session has expired. Please sign in again.',
        rateLimited: 'Too many requests. Please try again shortly.',
        rangeTooLarge: 'The date range cannot exceed {max} days.',
        fromAfterTo: 'Start date must be on or before the end date.',
        invalidRange: 'Please select a valid date range.',
        badRequest: 'Invalid request.',
        unknown: 'An error occurred while loading statistics.'
      }
    }
  },

  dataAnalytics: {
    seo: {
      title: 'ArbiWin | Analytical Software for Market Data and Statistics',
      description: 'Professional SaaS platform for comparative statistical analysis of market data in real time. Automated indexing of 22 independent sources.',
    },
    hero: {
      title: 'Mathematical edge through dynamic data analysis',
      subtitle: 'ArbiWin is a distributed software system for monitoring market inefficiencies. Compare and analyze mathematical values from 23 independent digital platforms in Bulgaria',
      cta: 'Open the Analytics Terminal',
    },
    tech: {
      title: 'What is a statistical inefficiency?',
      text: 'In any dynamic data system, market discrepancies arise. When Source A and Source B provide different mathematical values for the same event, our algorithm instantly computes the difference (the margin). ArbiWin software eliminates manual searching by providing you with clean mathematical facts for making informed decisions.',
    },
    matrix: {
      title: 'Simulation of a detected inefficiency',
      subtitle: 'Example of a systemic discrepancy reported by our scanner:',
      eventColumn: 'EVENT',
      marketColumn: 'MARKET',
      nodesColumn: 'INFORMATION NODES',
      marginColumn: 'MARGIN',
      actionColumn: 'ACTION',
      eventLabel: 'EVENT #{id} (Class A)',
      nodeLabel: 'Source_{n} (Position {pos})',
      calculator: 'Calculator',
      loading: 'Loading data...',
      error: 'Data temporarily unavailable',
      empty: 'No discrepancies detected at the moment',
    },
    market: {
      margin1X2: 'Final outcome (3-Way)',
      marginOverUnder2AndHalf: 'Threshold 2.5 (Binary)',
      marginOverUnder1AndHalf: 'Threshold 1.5 (Binary)',
      marginOverUnder3AndHalf: 'Threshold 3.5 (Binary)',
      marginBothScore: 'Dual node (Yes/No)',
      margin1Xvs2: '1X vs 2',
      marginX2vs1: 'X2 vs 1',
      margin12vsX: '12 vs X',
      default: 'Analytical market',
    },
    features: {
      title: 'Platform advantages',
      card1: {
        title: 'High-speed scanning',
        text: 'Our algorithm performs dynamic monitoring of 22 Bulgarian data platforms, processing thousands of requests.',
      },
      card2: {
        title: 'Precise filtering',
        text: 'Configure the software filters so that you only see the statistical indicators and results that match your personal analysis model.',
      },
      card3: {
        title: 'No subjectivity',
        text: 'Remove emotion from the process. ArbiWin provides you with pure mathematics and statistics, compatible with your analytical strategies.',
      },
    },
    bridge: {
      title: 'Want to unlock the real data sources?',
      text: 'In this demonstration the names of the data sources are hidden. Move to our official analytics panel to unmask all 22 platforms, use the advanced filters and start your free 3-day trial period.',
      cta: 'UNLOCK THE FULL PANEL NOW',
    },
  },

  promoBanner: {
    title: '🎉 Start Your 3-Day Free Trial! (New subscribers only)',
    text: 'Unlock all unmasked arbitrage situations and market anomalies instantly and activate our new intelligent Telegram bot. No need to stay in front of the screen – set your filters and receive notifications directly on your phone! Test the full capacity of the platform absolutely free.',
    cta: 'Start FREE',
    disclaimer: '*After the 3-day trial period expires, the subscription renews automatically at the standard price of €17.99/month. You can cancel at any time before that to avoid being charged.',
    dismiss: 'Close',
  },

  telegramDashboardBanner: {
    title: '🤖 You have an active subscription, but still watching the market manually?',
    text: 'Connect your free Telegram bot in 10 seconds! Set your personal filters and receive instant alerts for high margins and market anomalies directly on your phone, without staying in front of the screen.',
    cta: 'Click here and activate from the Profile menu',
    dismiss: 'Close',
  },

  static: {
    nav: {
      terms: 'Terms of Service',
      privacy: 'Privacy Policy',
      contact: 'Contact',
      about: 'About Us',
      subscribe: 'How to Subscribe'
    },
    terms: {
      title: 'Terms of Service',
      description: 'Terms of Use for ArbiWin.bg',
      companyInfo: 'Provided by: "VVSV TECH" EOOD\nRegistered office and address: Sofia, Svetla Street, 10\nFor legal questions, data protection and exercising your rights: legal@arbiwin.bg.\nFor general enquiries and technical support, you can also contact us at: support@arbiwin.bg.\nUIC 208695805',
      section1: {
        title: '1. Acceptance of Terms',
        content: 'These General Terms ("Terms") govern the use of the website and services provided by "VVSV TECH" EOOD ("ArbiWin.bg", "the Platform", "we", "our", "us").\n\nBy accessing or using the platform, you represent and warrant that:\n\nYou are 18 years of age or older; and\nIt is legal in your jurisdiction to view content related to sports analysis and statistics.\n\nWe do not perform active identity or age verification. Access is entirely at the user\'s own responsibility. If you do not agree with these Terms, discontinue use of the platform immediately.'
      },
      section2: {
        title: '2. Nature of the Service and Information Sources',
        content: '2.1 Informational Service\n\nArbiWin.bg is a specialised informational platform that provides:\n\nAutomated arbitrage alerts (masked for free users and unmasked for subscribers);\nAutomated market anomaly monitoring (Best Odds): A software tool that aggregates coefficients from different sources for elite sports leagues (Tier 1) and identifies values that deviate significantly from market averages (Spread);\nAutomated notification system (via Telegram) when user-defined parameters are detected;\nA limited number of unmasked signals (LIVE DEMO), available to unregistered users or users without an active subscription. These signals serve solely to illustrate the functionality of the ArbiWin.bg software and interface;\nEducational content and statistical analysis;\nPotential future AI-based predictions;\nSpecialised analytical modules (e.g. Near-Arb): Available on higher subscription plans (Ultimate), which track specific market relationships — including those with a small negative margin — using information feeds from physical (land-based) outlets of selected operators, at the client’s request, for in-depth market analysis.\n\n2.2 Data Aggregation and Independence\n\nArbiWin.bg acts as an independent aggregator of publicly available information. The platform indexes, processes and displays factual data (numerical coefficients and statistics) that are freely viewable on the internet, for the purpose of providing comparative market analysis to its users.\n\nThe user is expressly informed that:\n\nArbiWin.bg is not affiliated with, endorsed by, a partner of, or in a contractual relationship with any of the bookmakers or gambling operators whose data may be analysed on the platform.\n\nCoefficients represent factual data as at the time of extraction and are subject to constant change. ArbiWin.bg does not generate these coefficients but only reflects them for informational purposes.\n\n2.3 No Gambling Activity\n\nArbiWin.bg is NOT a bookmaker, does not organise gambling, does not accept bets, does not process betting payments and does not directly intermediate betting. The platform does not provide direct hyperlinks (affiliate links) to bookmakers at the time of launch of the service.\n\n2.4 Notification System (Notification Center)\n\nAs part of the paid subscription, ArbiWin.bg may provide functionality for receiving automatic notifications (e.g. via Telegram) when market inefficiencies (arbitrage) or market anomalies (Best Odds) above a user-defined threshold are detected.\n\nThis feature is provided as an additional convenience. ArbiWin.bg does not guarantee delivery of all notifications or their timeliness, as the process depends on third-party infrastructure (e.g. Telegram).\n\nThe user understands that market data is highly dynamic. It is entirely possible that by the time a notification is received, coefficients at the source have already changed. ArbiWin.bg is not liable for missed opportunities or financial outcomes resulting from delayed or inaccurate notifications, including when the user has enabled restrictive filters, the "Quiet hours" mode, or when system anti-spam restrictions apply.\n\n2.5 Monitoring for service improvement\n\nFor the purpose of software optimisation and improving the user experience, ArbiWin.bg may collect and analyse internal system data (first-party data) about how the user interacts with the different modules and features of the platform. This information is used exclusively for internal purposes and is processed in strict accordance with our Privacy Policy.'
      },
      section3: {
        title: '3. No Professional Advice',
        content: 'All information is provided for informational and entertainment purposes only, on an "as-is" and "as-available" basis.\n\nWe do not guarantee the accuracy, correctness, availability, timeliness or profitability of any alert, prediction or information. Sports analysis and arbitrage situations are theoretical mathematical models. Users are solely responsible for their own financial decisions and actions.'
      },
      section4: {
        title: '4. Accounts and Registration',
        content: 'To access full functionality, users must create an account by providing:\n\nFull name;\nEmail address;\nPassword.\n\nYou are responsible for keeping your credentials confidential.\n\nUnique Session Restriction\n\nYour subscription is strictly personal and non-commercial. Only one active session per account is allowed at any time. Starting a new session automatically terminates the previous one. Creating multiple accounts by one person, sharing an account and reselling access are strictly prohibited and result in immediate blocking without refund.'
      },
      section5: {
        title: '5. Subscription and Payments',
        content: '5.1 Subscription plans\n\nAccess to unmasked arbitrage alerts and full functionality requires an active paid subscription. ArbiWin.bg offers different subscription tiers (e.g. Premium, Ultimate), which provide a different range of analytical tools. Current prices and the services included in each plan are published on the Platform or agreed individually with the client.\n\n5.2 Payment Processing\n\nPayments are processed through a licensed payment service provider – Stripe. ArbiWin.bg does not store and has no access to your full card data.\n\n5.3 Automatic renewal and cancellation\n\nSubscriptions renew automatically every month until cancelled by the user. You may cancel your subscription at any time via your profile settings. When cancellation is requested, the user\'s access to unmasked arbitrage alerts and the platform\'s full functionality is terminated automatically and immediately.\n\n5.4 Right of Withdrawal (Digital Content Waiver)\n\nBy completing the order you request immediate access to the digital content and expressly agree that:\n\nYou lose your right to withdraw from the contract within 14 days (under Art. 57(1)(13) of the Consumer Rights Act and Directive 2011/83/EU) once access to the service has been provided.\n\n5.5 Refunds\n\nRefunds are made only where required by law (e.g. complete technical impossibility to access the service due to ArbiWin.bg\'s fault). Voluntary refunds are at our discretion.\n\n5.6 Promotional Campaigns and Discount Codes\n\nArbiWin.bg may periodically provide promotional codes that entitle users to a reduced price for the first month (or another specific period) of the subscription.\n\nWhen using a valid promo code, the user will be charged the reduced amount only for the specified promotional period.\n\nAfter the promotional period expires, the subscription automatically renews at the standard monthly price (without discount), unless cancelled by the user before the renewal date.\n\nPromo codes are for single use per user and cannot be combined with other offers.\n\n5.7 Free Trial\n\nThe platform may offer a free trial period (e.g. 3 days) for new users.\n\nTo activate the trial period, valid payment card details are required. During the trial period, the card will not be charged (only a temporary hold of a minimal amount from €0.00 to €1.00 may be applied for card verification purposes, which is released immediately).\n\nIf the user does not cancel their subscription before the trial period expires, the subscription automatically converts into a paid subscription and the card will be charged the standard monthly fee for the next billing period.\n\nThe user may cancel their subscription at any time during the trial period through their profile settings, in which case no charges will be applied.\n\n5.8 Change of subscription plan (Upgrade/Downgrade)\n\nUsers may move to a higher subscription plan (e.g. from Premium to Ultimate). When moving to a higher plan, whether manually or automatically, billing follows the terms of the new plan, and any amounts overcharged under the previous plan are credited proportionally (proration) through the payment provider.'
      },
      section6: {
        title: '6. Acceptable Use',
        content: 'The user undertakes NOT to:\n\nCopy, extract (scrape), reverse-engineer or automate access to our data by bots or scripts;\nCircumvent technical restrictions or security of the platform;\nUse the platform for commercial purposes or resale of data;\nUse the service in a jurisdiction where access to such content is prohibited.\n\nWe reserve the right to block access immediately upon detection of misuse.'
      },
      section7: {
        title: '7. No Guarantees and Limitation of Liability',
        content: 'To the fullest extent permitted by applicable law, ArbiWin.bg does not guarantee that the coefficients provided are current at the time of viewing by the user.\n\nThe data provided in the "Market anomalies" module is purely analytical. ArbiWin.bg does not guarantee that betting on maximum coefficients (Value betting) will lead to financial profit, as results depend on random sporting events.\n\nThe user is expressly informed and accepts that:\n\nData is updated periodically (at intervals), not in real time;\nCoefficients at the source (the bookmaker) change dynamically and may differ from those displayed on the platform in the period between two updates;\nArbiWin.bg is not liable for any discrepancies between the displayed coefficient and the actual coefficient at the time of placing the bet;\nMarket anomaly alerts (Best Odds / ArbiWin Value) show a statistical deviation of one coefficient from the market average and do NOT guarantee profit, nor that the coefficient will remain available at the operator. The module is limited to selected Tier 1 (elite) leagues for higher data quality. The user is solely responsible for independently verifying coefficients before any action;\nUnmasked demo signals (LIVE DEMO), available without a subscription, are provided on an "as is" basis solely for illustrative purposes. ArbiWin.bg is not liable for financial decisions or losses arising from the use of demo data. The user accepts that the demo signal may have higher latency (delay) compared to signals available under the paid subscription;\nSpecific modules such as "Near-Arb" deliberately display situations with a negative mathematical margin. The user expressly understands and agrees that using this data for real transactions results in a theoretical mathematical loss. ArbiWin.bg provides this data solely for statistical purposes and is not liable for the user\'s financial results, nor does it guarantee the receipt of any external bonuses, cashback or commissions from third parties (operators);\nFor modules that use data from physical (land-based) outlets: ArbiWin.bg bears no liability for delays in physical market positioning (offline execution). The user understands that local counter coefficients may be changed in real time by the operator, that outlet staff may refuse to accept a request or impose limits, and that applicable state taxes and fees for land-based premises are not calculated in the software.\n\nWe are not liable for:\n\nFinancial losses, lost profits or damage arising from the use of the information provided;\nInability to realise arbitrage due to third-party (bookmaker) account limits, coefficient changes or cancellation of bets by bookmakers.\n\nOur liability, if it cannot be fully excluded, is limited to the amount paid for the last monthly subscription. For users who use only free or demo services, ArbiWin.bg bears no financial liability.'
      },
      section8: {
        title: '8. Changes to the Service',
        content: 'We may modify the features, scope of markets monitored, information sources or functionality of the platform at any time for the purpose of improving the service.'
      },
      section9: {
        title: '9. Termination',
        content: 'Users may close their accounts at any time. We may terminate access in the event of breach of these Terms, fraud or attempts to share access in an unauthorised manner.'
      },
      section10: {
        title: '10. Intellectual Property and Trademarks',
        content: '10.1 ArbiWin.bg Ownership\n\nAll content, design, software code, algorithms, data compilations and analysis on the platform are the exclusive intellectual property of "VVSV TECH" EOOD.\n\n10.2 Third-Party Trademarks\n\nAll trademarks, company names (such as Bet365, Efbet, Winbet, etc.) and logos that may be mentioned in text on the platform are the property of their respective owners.\n\nThe use of these names by ArbiWin.bg is solely for the purpose of identifying the source of factual information (nominative fair use) and to assist the user in conducting comparative analysis. ArbiWin.bg does not claim any rights in these trademarks and their use does not imply affiliation, sponsorship or endorsement by the trademark owners.'
      },
      section11: {
        title: '11. Cookies',
        content: 'We use strictly necessary cookies for authentication, security and session management. We may use analytics and marketing cookies (e.g. Google Analytics, Meta Pixel) only with your consent, which you can give or withdraw via our cookie consent banner. You can change your choice at any time; see our Privacy Policy for details.'
      },
      section12: {
        title: '12. Data Protection',
        content: 'Personal data is processed in accordance with our Privacy Policy and in compliance with the GDPR. Data is stored on servers within the European Economic Area (Azure North Europe, Ireland).'
      },
      section13: {
        title: '13. Governing Law and Jurisdiction',
        content: 'These Terms are governed by the applicable legislation of the Republic of Bulgaria. All disputes shall be referred to the competent courts in Sofia.'
      },
      section14: {
        title: '14. Language',
        content: 'These Terms are provided in Bulgarian and English. In case of discrepancy, the Bulgarian version shall prevail.\n\nLast updated: 06.10.2026'
      }
    },
    privacy: {
      title: 'Privacy Policy',
      description: 'Privacy Policy and Data Protection for ArbiWin.bg',
      companyInfo: 'Data controller: "VVSV TECH" EOOD\nRegistered address: Sofia, Svetla Street 10\nFor legal questions, data protection and exercising your rights: legal@arbiwin.bg.\nFor general enquiries and technical support, you can also contact us at: support@arbiwin.bg.\nUIC 208695805\n\nLast updated: 27.07.2026',
      section1: {
        title: '1. Introduction',
        content: 'This Privacy Policy explains how "VVSV TECH" EOOD ("ArbiWin.bg", "we", "us") collects, uses, stores, and protects personal data when you use our website and services.\n\nWe process personal data in accordance with the EU General Data Protection Regulation (GDPR) and the applicable Bulgarian legislation.'
      },
      section2: {
        title: '2. Personal Data We Collect',
        content: 'We collect and process only the data necessary to operate the service.\n\n2.1 Data you provide directly\n\nWhen creating an account:\n\n• Full name;\n• Email address;\n• Password (stored in encrypted form).\n\nOptional: any communication you send us via email.\n\n• External application identifiers: If you choose to link your account to external notification platforms (e.g. Telegram), we will store your unique identifier (User ID) for the respective platform so that we can send you the requested notifications.\n\n2.2 Automatically collected data\n\nWhen you use our platform, we automatically collect certain data. It is divided into three categories:\n\nA) Essential technical data (No consent required)\nWe collect technical data that is strictly necessary to ensure secure access, proper functioning of the platform and prevention of misuse (such as account sharing). It includes:\n• Session identifiers;\n• Login timestamp;\n• Device or browser metadata (User-Agent) sufficient to enforce our single active session limitation;\n• Basic server logs (IP address, time of request).\n\nB) Product activity data / System logs (No consent required)\nWhen you use our services through your registered account, we collect internal system data about how you interact with the platform (e.g. switching between the arbitrage and market anomalies tabs, using the calculator, or opening event details). This data is collected and stored entirely on our secure servers (first-party data) and is not shared with external analytics platforms or advertising networks.\n\nC) Analytics and marketing data (Only with your consent)\nWhen you give your explicit consent via our cookie banner, we use third-party tools (Google Analytics 4 and Meta Pixel) to analyse site traffic, understand how users interact with the platform and optimise our advertising campaigns. These tools may collect data such as:\n• IP address (anonymised);\n• Device type and operating system;\n• Browser type;\n• Pages visited and interactions with the site (clicks, time spent on page).\n\nIf you do not give consent in the cookie banner, data in category "C" will not be collected.'
      },
      section3: {
        title: '3. Special Categories of Data',
        content: 'We do not collect or process any special category data (sensitive data) as defined under Art. 9 GDPR.'
      },
      section4: {
        title: '4. Purpose and Legal Basis of Processing',
        content: 'We process personal data only for the purposes listed below:\n\n4.1 To register and manage your user account\n\n• Legal basis: Art. 6(1)(b) GDPR – performance of a contract (Terms of Service).\n\n4.2 To provide our informational services\n\nIncluding access to arbitrage alerts and statistical analysis.\n\n• Legal basis: Art. 6(1)(b) GDPR – performance of a contract.\n\n4.3 For security and prevention of misuse\n\nIncluding our unique session management system that prevents simultaneous logins from multiple devices.\n\n• Legal basis: Art. 6(1)(f) GDPR – legitimate interest (protection of intellectual property and fraud prevention).\n\n4.4 For payment processing\n\nPayments are processed by a licensed provider (Stripe). We do not store full card data.\n\n• Legal basis: Art. 6(1)(b) GDPR.\n\n4.5 For compliance with legal obligations\n\nE.g. accounting records and tax obligations.\n\n• Legal basis: Art. 6(1)(c) GDPR – compliance with a legal obligation.\n\n4.6 Marketing emails\n\nOnly if you explicitly opt in.\n\n• Legal basis: Art. 6(1)(a) GDPR – consent.\n\n4.7 Product improvement and development\n\nWe analyse your product activity data to understand which features are most useful, optimise the user interface (UX) and develop our tools.\n• Legal basis: Art. 6(1)(f) GDPR – legitimate interest.'
      },
      section5: {
        title: '5. Cookies and tracking technologies',
        content: 'Our website uses cookies. We divide them into two main categories:\n\n5.1. Strictly necessary cookies (No consent required)\nThey are essential for the platform to function (authentication, session management, security). Without them the site cannot work properly.\n\n5.2. Analytics and marketing cookies (Consent required)\nWe use these cookies only if you explicitly allow them via our cookie banner.\nGoogle Analytics 4 (Google Ireland Limited): Helps us understand how users interact with the site so we can improve our service.\nMeta Pixel (Meta Platforms Ireland Limited): Helps us measure the effectiveness of our advertising on social networks and show you relevant offers.\n\nYou can change your preferences or withdraw your consent at any time by clicking on {{COOKIE_SETTINGS_LINK}}.'
      },
      section6: {
        title: '6. Payment Processing',
        content: 'We use Stripe as our payment processor.\n\nWe do not receive or store your bank card numbers. ArbiWin.bg processes only payment status confirmations (success/failure) and subscription metadata (renewal date, subscription status).\n\nStripe acts as an independent data controller in respect of financial information.'
      },
      section7: {
        title: '7. Data Storage Location',
        content: 'All data is stored on Microsoft Azure infrastructure – North Europe (Ireland).\n\nWe do not transfer personal data outside the European Economic Area (EEA).'
      },
      section8: {
        title: '8. Data Retention',
        content: 'We retain your data only as long as necessary for the purposes for which it was collected and in accordance with legal requirements:\n\n• Active account information: While the account is active.\n• Accounting and payment data: 10 years (in accordance with the Bulgarian Accountancy Act), whether or not the account is deleted.\n• Server logs and session data: Up to 12 months (for security purposes).\n• Product activity logs: Retained for 90 days from the date of the event, after which they are automatically deleted from our systems.\n• Inactive accounts (no payments): Up to 24 months after last activity.'
      },
      section9: {
        title: '9. Data Security',
        content: 'We maintain high technical security standards, including:\n\n• Encrypted connections (SSL/HTTPS);\n• Secure password hashing (passwords are never stored in plain text);\n• Strict database access controls;\n• Protections provided by Azure infrastructure.'
      },
      section10: {
        title: '10. Sharing of Personal Data',
        content: 'We do not sell or rent personal data to third parties.\n\nData may be shared only where strictly necessary with:\n\n• Payment processors (Stripe);\n• Hosting provider (Microsoft Azure);\n• Public authorities (only where required by law);\n• Communication service providers (e.g. Telegram FZ-LLC): Only if you explicitly activate the notification feature via their platforms.'
      },
      section11: {
        title: '11. Third-Party Websites',
        content: 'The platform may contain links to third-party websites (e.g. bookmaker names). This Privacy Policy does not apply to those websites. We are not responsible for the privacy practices of third parties.'
      },
      section12: {
        title: '12. Your Rights',
        content: 'You have the following rights in respect of your personal data:\n\n• Right of access;\n• Right to rectification;\n• Right to erasure ("right to be forgotten"), except for data we are required to retain by law (e.g. accounting data);\n• Right to restriction of processing;\n• Right to data portability;\n• Right to object.\n\nTo exercise your rights, please contact us at: legal@arbiwin.bg.'
      },
      section13: {
        title: '13. Children',
        content: 'The service is intended only for persons who have reached 18 years of age. We do not knowingly process data of minors.'
      },
      section14: {
        title: '14. Changes to This Policy',
        content: 'We may update this Privacy Policy periodically. Material changes will be communicated via a notice on the website or by email.'
      }
    },
    contact: {
      title: 'Contact Us',
      description: 'Contact the ArbiWin.bg team',
      intro: 'Have a question about the service or need technical support? Our team is here to help.',
      section1: {
        title: '1. Customer support and technical enquiries',
        description: 'For questions about subscriptions, platform access or technical issues:',
        emailLabel: '📧 Email',
        email: 'support@arbiwin.bg'
      },
      section2: {
        title: '2. Legal questions and personal data',
        description: 'For questions related to the Terms of Service, Privacy Policy or exercising your GDPR rights:',
        emailLabel: '📧 Email',
        email: 'legal@arbiwin.bg'
      },
      instructions: {
        title: 'Tips for faster service',
        intro: 'To process your enquiry as quickly and securely as possible, please:',
        item1: 'Write from your registered email address: For your security, we only provide account information if the enquiry is sent from the email address associated with your profile.',
        item2: 'Describe the issue: If reporting a technical problem, please include a brief description or a screenshot.'
      },
      response: {
        title: 'Response time',
        time: 'We aim to respond to all enquiries within 24 hours. During busy periods or in complex cases, the response time may be up to 5 working days.'
      },
      footer: {
        company: '"VVSV TECH" EOOD',
        address: 'Sofia, Svetla Street 10',
        terms: 'Terms of Service',
        privacy: 'Privacy Policy'
      }
    },
    about: {
      title: 'About Us',
      description: 'Information about ArbiWin.bg',
      section1: {
        title: 'Who We Are',
        content: 'ArbiWin.bg is a specialized information platform for statistical analysis of sports markets. We provide tools to identify mathematical advantages (arbitrage situations), focused entirely on the licensed market in Bulgaria.'
      },
      section2: {
        title: 'Our Mission',
        content: 'Our goal is to give users transparent access to aggregated market data, helping them make informed decisions based on facts and mathematical models, not on gambling.'
      },
      section3: {
        title: 'Our Advantages',
        content: 'Why choose ArbiWin.bg:',
        item1: 'Focus on the local market – We analyse data only from operators licensed in Bulgaria, which guarantees accessibility for Bulgarian users.',
        item2: 'Dynamic monitoring – Our system scans the market and updates coefficient information at frequent intervals.',
        item3: 'Integrated calculator – Automatic calculation of optimal fund allocation for each arbitrage situation.',
        item4: 'Accessibility – An intuitive interface designed for both beginners and advanced users.'
      },
      section4: {
        title: 'Our Team',
        content: 'Behind ArbiWin.bg is a team of specialists in data analysis (Data Science) and software engineering. We combine technical skills with in-depth knowledge of sports markets to create a high-value product.'
      },
      section5: {
        title: 'Contact Us',
        content: 'We value your feedback. If you have questions or suggestions for improving the platform, contact us at:',
        supportEmail: '📧 support@arbiwin.bg'
      }
    },
    subscribe: {
      title: 'How to Subscribe',
      description: 'Information about subscription and pricing',
      section1: {
        title: 'Why Subscribe',
        content: 'With an active subscription you unlock the full potential of the platform: ArbiWin SureBet (arbitrage), ArbiWin Value (Best Odds), Telegram alerts, automatic calculator and professional filters.'
      },
      section2: {
        title: 'Pricing and Plans',
        content: 'Our platform offers a single subscription plan with access to all features.'
      },
      pricing: {
        title: 'ArbiWin Premium: Full analytical access',
        amount: '€17.99',
        period: '(per month)',
        featuresIncludes: 'What\'s included:',
        feature1: '✅ Arbitrage module: Unlimited access to all arbitrage situations',
        feature2: '✅ Market Anomalies module: Radar for highest values vs market averages (Tier 1 leagues only)',
        feature3: '✅ Telegram alerts: Automatic notifications when favourable positions are detected',
        feature4: '✅ Integrated calculator: Capital optimization for arbitrage',
        feature5: '✅ Dynamic data refresh from 23 operators',
        button: 'Register Now',
        promoText: '🎁 3-Day Free Trial Period (New subscribers only)',
        promoDisclaimer: '(Enter a payment method to activate. You will not be charged today. Billing of €17.99 starts automatically after the 3-day trial expires).',
      },
      section3: {
        title: 'How to Get Started',
        content: 'Follow these steps to start using ArbiWin.bg:'
      },
      steps: {
        step1: 'Create an account – register with your email address.',
        step2: 'Start the free trial – enter a payment method in Stripe’s secure system (you will not be charged today).',
        step3: 'Immediate access – right after activation you can see all hidden data free for 3 days.',
        step4: 'Discover opportunities – use the filters to find situations that match your strategy.',
        step5: 'Optimize your game – use the calculator for precise fund allocation.'
      },
      section4: {
        title: 'Frequently Asked Questions',
        faqQuestion: 'Will I be charged today?',
        content: 'No. The first 3 days are completely free. You will be charged the standard monthly fee only on day 4, unless you cancel your subscription before then.',
        faqQuestion2: 'Can I cancel?',
        content2: 'Yes, you can cancel your subscription at any time through your profile settings.'
      },
      section5: {
        title: 'Support',
        content: 'If you have questions about payments or subscriptions, please contact us at:',
        supportEmail: '📧 support@arbiwin.bg'
      },
      footer: {
        company: '"VVSV TECH" EOOD',
        address: 'Sofia, Svetla Street 10',
        terms: 'Terms of Service',
        privacy: 'Privacy Policy'
      }
    }
  },

  marketing: {
    bulgarianFocus: {
      title: 'Built for the Bulgarian Market',
      description: 'We are the only analytics platform dedicated exclusively to licensed Bulgarian operators. We ensure full relevance to your location.',
      benefit1: 'Licensed operators only',
      benefit2: 'Compliance with local standards',
      benefit3: 'Localized support',
      benefit4: 'Relevant market insights',
      visualText: '100% BG Focus'
    },
    advantages: {
      title: 'Key Advantages',
      subtitle: 'Why ArbiWin is the smart choice',
      advantage1: {
        title: 'Speed',
        description: 'Fast data refresh rates ensure you see opportunities before they vanish.'
      },
      advantage2: {
        title: 'Safety',
        description: 'We only aggregate data from regulated entities.'
      },
      advantage3: {
        title: 'Transparency',
        description: 'No hidden fees. Access all tools with one subscription.'
      },
      advantage4: {
        title: 'Usability',
        description: 'Clean UI designed for efficiency, not confusion.'
      }
    },
    comparison: {
      title: 'Comparison with Other Platforms',
      subtitle: 'See why ArbiWin.bg is the best choice',
      feature: 'Feature',
      otherPlatforms: 'Other Platforms',
      arbiwin: 'ArbiWin.bg',
      row1: {
        feature: 'Focus on Bulgarian market',
        other: 'No',
        us: 'Yes'
      },
      row2: {
        feature: 'Work with licensed Bulgarian bookmakers',
        other: 'Limited',
        us: 'Full Support'
      },
      row3: {
        feature: 'Real-time data (10 minutes)',
        other: '15-30 minutes',
        us: '10 minutes'
      },
      row4: {
        feature: 'Automatic calculator',
        other: 'Manual calculation',
        us: 'Automatic'
      },
      row5: {
        feature: 'Localized content',
        other: 'English only',
        us: 'Bulgarian and English'
      }
    },
    benefits: {
      title: 'Platform Value',
      subtitle: 'Tools for smarter sports trading',
      benefit1: {
        title: 'Hedge Your Positions',
        description: 'Learn to cover all outcomes to secure margins regardless of the result.'
      },
      benefit2: {
        title: 'Telegram Automation',
        description: 'Get instant signals directly on your phone through our Telegram bot. You set the margin, we send you the match.'
      },
      benefit3: {
        title: 'Precision',
        description: 'Calculators eliminate mental math errors.'
      },
      benefit4: {
        title: 'Legitimacy',
        description: 'Focus on legal, tax-paid winnings via licensed operators.'
      },
      benefit5: {
        title: 'Filtering',
        description: 'See only the opportunities that match your strategy.'
      },
      benefit6: {
        title: 'Education',
        description: 'Guides and tutorials to improve your trading discipline.'
      }
    },
    trust: {
      title: 'Our Commitments',
      subtitle: 'Reliable Data & Service',
      trust1: {
        title: 'Legal Compliance',
        description: 'We operate in full compliance with Bulgarian and EU legislation. We are a provider of professional sports analytics.'
      },
      trust2: {
        title: 'Clear Pricing',
        description: 'Simple monthly subscription. Cancel anytime.'
      },
      trust3: {
        title: 'Customer Care',
        description: 'Dedicated support team to assist with platform usage.'
      },
      trust4: {
        title: 'User Base',
        description: 'Join a growing community of analytical sports traders.'
      }
    },
    cta: {
      title: 'Ready to analyze the market?',
      description: 'Get access to professional sports trading data today.',
      button: 'Get Started',
      guarantee: '14-day money-back guarantee'
    }
  },

  header: {
    login: 'Login',
    register: 'Register',
    menu: 'Menu',
  },

  filters: {
    all: 'All',
    selectAll: 'Select All',
    deselectAll: 'Deselect All',
    filterByBookmaker: 'Search arbitrage opportunities by operator',
    searchBookmakers: 'Search operator...',
    clearSearch: 'Clear search',
    noBookmakersFound: 'No bookmakers found',
    selectedBookmakers: 'Selected Operators',
    inactiveMode: 'View Only',
    inactiveMessage: 'Subscribe to filter by specific operators and view full market data.',
    applyFilters: 'Apply',
    resetFilters: 'Reset',
    activeFilters: 'Active Filters',
    loading: 'Loading bookmakers...',
    refresh: 'Refresh',
    refreshing: 'Refreshing...',
    lastUpdate: 'Last update',
    noUpdates: 'No updates',
    justNow: 'Just now',
    oneMinuteAgo: '1 minute ago',
    minutesAgo: '{minutes} minutes ago',
    applying: 'Applying...',
      selectAtLeastOne: 'Please select at least one bookmaker',
      collapse: 'Collapse',
      expand: 'Expand',
      // Filter Indicators
      indicators: {
        ariaLabel: 'Active filter indicators',
        activeFilters: 'Active Filters',
        clearAll: 'Clear All',
        selectedBookmakers: 'Selected Operators',
        selected: 'Selected',
        remove: 'Remove',
        more: 'more',
        showHidden: 'Show hidden ({count})',
        hiddenBookmakers: 'Hidden Bookmakers',
      },
      // Filter Search
      search: {
        placeholder: 'Search operators...',
        ariaLabel: 'Search operators',
        description: 'Enter bookmaker name to search',
        clear: 'Clear search',
        suggestions: 'Search suggestions',
        noResults: 'No results for "{term}"',
      },
      // Filter Reset
      reset: {
        ariaLabel: 'Reset filters',
        title: 'Reset filters',
        reset: 'Reset',
        resetting: 'Resetting...',
        clearAllAriaLabel: 'Clear all filters',
        clearAllTitle: 'Clear all filters',
        clearAll: 'Clear All',
        confirmTitle: 'Confirm Reset',
        confirmMessage: 'Are you sure you want to reset all filters?',
        cancel: 'Cancel',
        confirm: 'Confirm',
      },
      // Filter Drawer
      drawer: {
        title: 'Filters',
        description: 'Configure bookmaker filters',
        close: 'Close',
        searchPlaceholder: 'Search operators...',
        apply: 'Apply',
      },
      // Filter Shortcuts
      shortcuts: {
        title: 'Quick Selections',
        description: 'Choose predefined bookmaker combinations',
        all: 'All',
        allDescription: 'Show all available bookmakers',
        popular: 'Popular',
        popularDescription: 'Most popular bookmakers in Bulgaria',
        bulgarian: 'Bulgarian',
        bulgarianDescription: 'Bulgarian bookmakers',
        international: 'International',
        internationalDescription: 'International bookmakers',
        bookmakers: 'bookmakers',
        createCustom: 'Create Custom',
      },
  },

  footer: {
    description: 'Intelligent platform for data aggregation, statistics, and identifying mathematical advantages.',
    quickLinks: 'Quick Links',
    learnMore: 'Learn More',
    rights: '© {year} ArbiWin.bg. All rights reserved.',
    copyright: '© 2026 ArbiWin.bg. All rights reserved.',
    terms: 'Terms of Service',
    privacy: 'Privacy Policy',
    contact: 'Contact',
    cookieSettings: 'Cookie settings',
    about: 'About Us',
    howToSubscribe: 'How to Subscribe',
    faq: 'FAQ',
  },

  cookieConsent: {
    title: 'We value your privacy',
    message: 'We and our partners use cookies and similar technologies to ensure our website works properly, to analyse traffic, to personalise content and to show you ads tailored to your interests.\n\nBy clicking "Accept all", you consent to the use of all cookies.\n\nBy clicking "Essential only", only the cookies that are strictly necessary for the site to function will be used. You can change your preferences at any time using the "Settings" button. For more information, please see our',
    acceptAll: 'Accept all',
    essentialOnly: 'Essential only',
    settings: 'Settings',
    privacyLink: 'Privacy Policy',
    settingsTitle: 'Cookie preferences',
    necessaryCookies: 'Necessary cookies (always active)',
    necessaryCookiesDesc: 'Required for authentication, security and session management. The site cannot function without them.',
    analyticsMarketingCookies: 'Analytics and marketing (GA4, Meta Pixel)',
    analyticsMarketingDesc: 'Used to improve our service and measure campaign performance.',
    savePreferences: 'Save preferences',
  },

  feedback: {
    loading: 'Loading...',
    error: 'An error occurred',
    success: 'Success',
    retry: 'Try again',
  },

  validation: {
    required: 'This field is required',
    emailInvalid: 'Invalid email address',
    passwordTooShort: 'Password must be at least {min} characters',
    passwordsDoNotMatch: 'Passwords do not match',
    minValue: 'Minimum value: {min}',
    maxValue: 'Maximum value: {max}',
    fullName: 'Enter your full name',
    fullNameMinLength: 'Full name must be at least 2 characters',
  },

  errors: {
    generic: 'Something went wrong. Please try again later.',
    network: 'Connection problem. Check your internet connection.',
    unauthorized: 'You need to log in.',
    forbidden: 'You do not have the required permissions.',
    notFound: 'Resource not found.',
    serverError: 'Server error. Please try again.',
    subscriptionRequired: 'Active subscription required to access this feature.',
    http: {
      401: 'Invalid session or expired token. Please log in again.',
      402: 'Active subscription required.',
      403: 'Action is forbidden.',
      404: 'Not found.',
      500: 'Internal server error.',
    },
  },

  auth: {
    login: {
      title: 'Login',
      email: 'Email',
      password: 'Password',
      rememberMe: 'Remember me',
      submit: 'Login',
      forgotPassword: 'Forgot password?',
      noAccount: "Don't have an account?",
      success: 'Logged in successfully',
      error: 'Login failed',
    },
    register: {
      title: 'Register',
      fullName: 'Full Name',
      email: 'Email',
      password: 'Password',
      confirmPassword: 'Confirm Password',
      submit: 'Create Account',
      success: 'Registration successful',
      successMessage: 'Your account has been created successfully! Please log in with your credentials.',
      goToLogin: 'Go to Login',
      hasAccount: 'Already have an account?',
      error: 'Registration failed',
      ageConfirmation: 'I confirm that I am at least 18 years old',
      ageConfirmationRequired: 'You must confirm that you are at least 18 years old',
      termsPrivacyAcceptPrefix: 'I have read and accept the ',
      termsPrivacyAcceptAnd: ' and ',
      termsLinkText: 'General Terms',
      privacyLinkText: 'Privacy Policy',
      termsPrivacyAcceptRequired: 'You must accept the General Terms and Privacy Policy.',
    },
    forgotPassword: {
      title: 'Forgot Password',
      subtitle: 'Enter your email and we\'ll send you a password reset link',
      email: 'Email',
      sendResetLink: 'Send Reset Link',
      sending: 'Sending...',
      success: 'Reset link sent',
      successMessage: 'Check your email for a password reset link. The link is valid for 24 hours.',
      backToLogin: 'Back to Login',
      error: 'Error sending reset link',
    },
    resetPassword: {
      title: 'New Password',
      subtitle: 'Enter your new password',
      newPassword: 'New Password',
      confirmNewPassword: 'Confirm New Password',
      resetPassword: 'Save Password',
      resetting: 'Saving...',
      success: 'Password reset successfully',
      successMessage: 'Your password has been changed successfully! You can now log in with your new password.',
      backToLogin: 'Back to Login',
      invalidToken: 'Invalid or expired reset link',
      error: 'Error resetting password',
    },
    changePassword: {
      title: 'Change Password',
      subtitle: 'Enter your current password and choose a new one',
      currentPassword: 'Current Password',
      currentPasswordPlaceholder: 'Enter your current password',
      newPassword: 'New Password',
      newPasswordPlaceholder: 'Enter new password',
      confirmPassword: 'Confirm New Password',
      confirmPasswordPlaceholder: 'Confirm new password',
      requirements: 'Password must be at least 8 characters long',
      changePassword: 'Change Password',
      changing: 'Changing...',
      cancel: 'Cancel',
      returnToProfile: 'Return to Profile',
      success: {
        title: 'Password Changed Successfully',
        message: 'Your password has been changed successfully! You can now use your new password to log in.',
      },
      errors: {
        currentPasswordRequired: 'Current password is required',
        newPasswordRequired: 'New password is required',
        passwordTooShort: 'Password must be at least 8 characters long',
        passwordsDoNotMatch: 'New password and confirmation do not match',
        samePassword: 'New password must be different from current password',
        currentPasswordIncorrect: 'Current password is incorrect',
        generic: 'Error changing password',
        networkError: 'Network error. Please try again.',
      },
    },

    // Calculator translations
    calculator: {
      title: 'Surebet Calculator',
      marketType: 'Market Type',
      market2Way: '2-Way Market (e.g. Over/Under)',
      market3Way: '3-Way Market (e.g. 1X2)',
      coefficient: 'Coefficient',
      bookmaker: 'Bookmaker',
      outcome: 'Outcome',
      totalStake: 'Total Stake (BGN)',
      enterTotalStake: 'Enter total stake',
      calculatedStakes: 'Calculated Stakes',
      stakeFor: 'Stake for',
      guaranteedProfit: 'Expected Return (BGN)',
      reset: 'Reset',
      calculate: 'Calculate',
      calculating: 'Calculating...',
      profit: 'Profit',
      loss: 'Loss',
      neutral: 'Neutral',
      // Modal translations
      modalTitle: 'Arbitrage Calculator',
      modalTitleWithEvent: 'Calculator for {teamOne} vs {teamTwo}',
      modalSubtitle: 'Calculate optimal stake distribution for expected return',
      modalSubtitleWithEvent: '{championship} • {date} {time}',
      closeModal: 'Close calculator',
      close: 'Close',
      modalInfo: 'Data pre-populated from the selected arbitrage opportunity',
      // Outcome translations
      outcome1: 'Home Win',
      outcomeX: 'Draw',
      outcome2: 'Away Win',
      outcomeOver25: 'Over 2.5',
      outcomeUnder25: 'Under 2.5',
      outcomeBothScoreYes: 'Both Teams to Score',
      outcomeBothScoreNo: 'Not Both Teams to Score',
      outcome1X: '1X',
      outcomeX2: 'X2',
      outcome12: '12',
      outcomeYesGoal: 'Goal',
      outcomeNoGoal: 'No Goal',
      outcomeOver15: 'Over 1.5',
      outcomeUnder15: 'Under 1.5',
      outcomeOver35: 'Over 3.5',
      outcomeUnder35: 'Under 3.5',
      // Stake Calculator translations
      stakeCalculator: {
        title: 'Stake Distribution',
        totalStake: 'Total Stake',
        guaranteedProfit: 'Expected Return',
        profitPercentage: 'Profit %',
        arbitrageMargin: 'Arbitrage Margin',
        bookmaker: 'Bookmaker',
        outcome: 'Outcome',
        odds: 'Odds',
        stake: 'Stake',
        percentage: 'Percentage',
        return: 'Return',
        adjustment: 'Adjustment',
        adjustmentAria: 'Adjust stake for {bookmaker}',
        resetAdjustments: 'Reset Adjustments',
        copyStakes: 'Copy Stakes',
        copied: 'Copied!',
        noDistribution: 'No stake distribution available',
        noDistributionHint: 'Enter valid odds and total stake to calculate distribution',
        validationErrors: 'Validation Errors',
        minStakeError: 'Minimum stake is {min} BGN',
        maxStakeError: 'Maximum stake is {max} BGN',
        negativeStakeError: 'Stake cannot be negative',
        totalStakeError: 'Total calculated stake does not match input',
      },
      // Profit Calculator translations
      profitCalculator: {
        title: 'Profit Analysis',
        toggleComparison: 'Toggle Comparison',
        guaranteedProfit: 'Expected Return',
        totalROI: 'Total ROI',
        arbitrageMargin: 'Arbitrage Margin',
        riskLevel: 'Risk Level',
        riskFree: 'Risk-Free',
        profitScenarios: 'Profit Scenarios',
        scenariosDescription: 'Expected return regardless of outcome',
        stake: 'Stake',
        odds: 'Odds',
        return: 'Return',
        profit: 'Profit',
        roi: 'ROI',
        profitBreakdown: 'Profit Breakdown by Bookmaker',
        stakePercentage: 'Stake %',
        potentialReturn: 'Potential Return',
        comparisonTitle: 'Comparison with Single Bookmaker Betting',
        comparisonMethod: 'Comparison Method',
        highestOdds: 'Highest Odds',
        averageOdds: 'Average Odds',
        lowestOdds: 'Lowest Odds',
        singleBookmaker: 'Single Bookmaker',
        potentialProfit: 'Potential Profit',
        highRisk: 'High Risk',
        arbitrageAdvantage: 'Arbitrage Advantage',
        arbitrageAdvantageDescription: 'Expected return vs. potential return with risk',
        riskFreeTitle: 'Risk-Free Arbitrage',
        riskFreeDescription: 'Arbitrage betting guarantees profit regardless of the outcome. Unlike traditional betting, you cannot lose money with a properly calculated arbitrage opportunity.',
        guaranteedProfitBenefit: 'Expected return on every outcome',
        noRiskBenefit: 'No risk of losing your stake',
        consistentReturnsBenefit: 'Consistent returns regardless of results',
      },
    },
    fields: {
      email: 'Email',
      password: 'Password',
      newPassword: 'New Password',
      confirmNewPassword: 'Confirm New Password',
    },
    placeholders: {
      email: 'Enter your email',
      newPassword: 'Enter new password',
      confirmNewPassword: 'Confirm new password',
    },
    validation: {
      emailRequired: 'Email is required',
      emailInvalid: 'Invalid email address',
      passwordRequired: 'Password is required',
      confirmPasswordRequired: 'Password confirmation is required',
      passwordsDoNotMatch: 'Passwords do not match',
      passwordInvalid: 'Password does not meet requirements',
      minLength: 'At least 8 characters',
      hasUpperCase: 'Uppercase letter',
      hasLowerCase: 'Lowercase letter',
      hasNumbers: 'Number',
      hasSpecialChar: 'Special character',
    },
    sessionConflict: {
      title: 'Another Session is Active',
      message: 'Another session is active on this account. Please log in again.',
      loginButton: 'Login'
    },
    sessionTerminated: {
      title: 'Session Terminated',
      message: 'Your session has been terminated. Please log in again.',
      loginButton: 'Login'
    },
    sessionInvalid: {
      title: 'Session Not Valid',
      message: 'Your session is not valid or has been revoked. Please log out and log in again to continue.',
      logoutButton: 'Logout'
    },
  },

  subscription: {
    title: 'ArbiWin Premium',
    titleUltimate: 'ArbiWin Ultimate',
    status: {
      active: 'Active',
      inactive: 'Inactive',
      expired: 'Expired',
      none: 'No Subscription',
      suspended: 'Suspended',
      cancelled: 'Cancelled',
      loading: 'Loading...',
      error: 'Error',
    },
    types: {
      basic: 'Basic Plan',
      premium: 'Premium Plan',
      enterprise: 'Enterprise Plan',
      none: 'No Plan',
    },
    pricing: {
      basic: '€17.99/month',
      premium: '€17.99/month',
      enterprise: '€17.99/month',
      ultimate: '€200/month',
      none: 'Free',
    },
    labels: {
      status: 'Subscription Status',
      expiryDate: 'Expiry Date',
      renewalDate: 'Renewal Date',
      nextPayment: 'Next Payment',
      activatedDate: 'Activated Date',
      daysRemaining: 'Days Remaining',
    },
    days: {
      remaining: 'days left',
      overdue: 'days overdue',
    },
    dates: {
      notSet: 'Not set',
      invalid: 'Invalid date',
    },
    actions: {
      activate: 'Activate Subscription',
      activating: 'Activating...',
      changePlan: 'Change Plan',
      cancel: 'Cancel Subscription',
      cancelling: 'Cancelling...',
      renew: 'Renew Subscription',
      renewing: 'Renewing...',
      retry: 'Try Again',
      goBack: 'Go Back',
    },
    modals: {
      activate: {
        title: 'Confirm Subscription Activation',
        message: 'Are you sure you want to activate your subscription?',
        confirm: 'Confirm'
      },
      cancel: {
        title: 'Confirm Subscription Cancellation',
        message: 'Are you sure you want to cancel your subscription? This action will result in the loss of access to premium features and sure bet opportunities.',
        confirm: 'Confirm'
      },
      cancelButton: 'Cancel',
      keep: 'Cancel'
    },
    errors: {
      activationFailed: 'Failed to activate subscription. Please try again.',
      cancellationFailed: 'Failed to cancel subscription. Please try again.',
      networkError: 'Network error. Please check your internet connection.',
      serverError: 'Server error. Please try again later.',
      checkTitle: 'Subscription Check Error',
      checkStatusFailed: 'Unable to check subscription status. Please try again.'
    },
    paymentRequired: {
      title: 'Active Subscription Required',
      message: 'An active subscription is required to access this feature.',
      messageWithFeature: 'An active subscription is required to access {feature}.',
      featuresTitle: 'What you get with subscription:',
      features: {
        surebets: 'Arbitrage Opportunities',
        calculator: 'Betting Calculator',
        realTime: 'Real-time Data',
        support: 'Priority Support'
      },
      perMonth: 'per month',
      pricingNote: 'First month is free',
      later: 'Later',
      activateNow: 'Activate Now'
    },
    loading: {
      status: 'Loading subscription status...',
      activation: 'Activating subscription...',
      cancellation: 'Cancelling subscription...'
    },
    activate: 'Activate subscription',
    activateConfirm: 'Are you sure you want to activate the subscription?',
    activatedSuccess: 'Subscription activated successfully!',
    inactiveNotice: 'Inactive subscription',
    required: 'Active subscription required to access this feature',
    expiry: 'Valid until: {date}',
    renewal: 'Renewal date: {date}',
    checking: 'Checking subscription...',
    retryAttempt: 'Attempt {count}',
  },

  stripe: {
    product: {
      title: 'ArbiWin Ultimate Premium',
      price: '€17.99 / month',
      checkout: 'Activate Free Trial',
      manageBilling: 'Manage cards & invoices',
      noPaymentData: 'You have no saved payment data yet.',
      securityNote: '100% Secure with Stripe. Your data is encrypted. No additional fees.',
    },
    success: {
      title: 'Subscription to ArbiWin Premium successful!',
      heroTitle: 'Subscription activated successfully!',
      heroSubtitle: 'You now have access to all analysis tools and arbitrage opportunities. Good luck!',
      orderDetails: 'Order details',
      plan: 'Plan',
      status: 'Status',
      statusActive: 'Active',
      nextPayment: 'Next payment',
      nextPaymentValue: '–',
      gotoSurebets: 'To arbitrage opportunities',
      manageBilling: 'Manage your billing information',
    },
    messages: {
      canceled: "Order canceled -- continue to shop around and checkout when you're ready.",
    },
    errors: {
      notAuthenticated: 'Please log in to continue',
      checkoutFailed: 'Failed to create checkout session',
      portalFailed: 'Failed to create portal session',
      noSessionId: 'Session ID is missing',
    },
  },

  profile: {
    title: 'Profile',
    sections: {
      accountInfo: 'Account Information',
      securitySubscription: 'Security & Subscription',
      subscriptionStatus: 'Subscription Status'
    },
    fields: {
      email: 'Email Address'
    },
    actions: {
      changePassword: 'Change Password',
      subscriptionDetails: 'Subscription Details',
      logout: 'Log Out',
      back: 'Back'
    },
    notifications: {
      title: '🔔 Notification Center',
      subtitle: 'Receive instant alerts for new market inefficiencies and anomalies directly on your phone.',
      loading: 'Loading settings...',
      subscriptionRequired: 'An active subscription is required to manage Telegram notifications.',
      connected: 'Telegram connected successfully!',
      disconnected: 'Telegram has been disconnected.',
      enabled: 'Notifications enabled.',
      saved: 'Settings saved',
      linkError: 'Failed to generate Telegram link.',
      connect: {
        heading: 'Connect Telegram',
        text: 'To enable alerts, connect your ArbiWin account with our official Telegram bot.',
        button: 'Connect Telegram',
        helper: 'Telegram will open in a new tab. Press the START button (not plain /start) — it sends your unique linking code.',
        waiting: 'Waiting for Telegram confirmation...',
        pollTimeout: 'No Telegram confirmation received. Open the link again and press START.'
      },
      settings: {
        heading: 'Notification settings',
        generalHeading: 'General settings',
        enabledToggle: 'Active alerts',
        paused: 'Alerts are paused',
        quietHoursToggle: '🌙 Quiet hours (00:00–08:00)',
        quietHoursHelper: 'When enabled, alerts are automatically paused between 00:00 and 08:00 (Europe/Sofia).',
        arbitrageFilterHeading: '⚖️ Filter: Arbitrage situations',
        arbitrageFilterToggle: 'Enable arbitrage alerts',
        marginLabel: 'Notify me when the system detects a guaranteed arbitrage margin greater than:',
        marginPlaceholder: 'e.g. 3.0',
        bestOddsFilterHeading: '🚀 Filter: Market anomalies (Best Odds - Top Leagues only)',
        bestOddsFilterToggle: 'Enable Best Odds alerts',
        spreadLabel: 'Notify me when the system detects a value whose deviation (Spread) from the market average is above:',
        spreadPlaceholder: 'e.g. 5.0',
        antiSpam: {
          title: '🛡️ Smart Anti-Spam protection:',
          intro: 'To avoid flooding your chat, our system uses a dual intelligent filter:',
          arbitrage: 'For Arbitrage: After you receive a signal, alerts for the same match are paused for the next 4 hours.',
          bestOdds: 'For Market Anomalies: You receive an alert only when the value (coefficient) rises and reaches a new peak. After that, alerts for that specific outcome (e.g. Home Win) are paused for 24 hours. However, if an anomaly appears for another outcome in the same match (e.g. Draw), you will be notified immediately.',
        },
        save: 'Save settings',
        savedButton: 'Saved ✓',
        saveErrorGeneric: 'Could not save settings. Please try again.',
        disconnect: 'Disconnect Telegram',
        minFloorError: 'Minimum threshold is 1.0%.',
        minSpreadFloorError: 'Minimum threshold is 5.0%.'
      }
    }
  },

  surebets: {
    list: {
      title: 'Arbitrage Opportunities',
      subtitle: 'Arbitrage opportunities analysis and dynamic market data for sports events.',
      noData: 'No arbitrage opportunities available at the moment',
      loading: 'Loading data...',
      refreshing: 'Refreshing...',
      lastUpdate: 'Last update',
      profit: 'Profit',
      margin: 'Margin',
      event: 'Event',
      date: 'Date',
      time: 'Time',
      championship: 'Championship',
      sport: 'Sport',
      refreshButton: 'Refresh Data',
      calculatorButton: 'Calculator',
      marginFlag: 'Profitable',
      noMarginData: 'No margin data',
    },
    filters: {
      title: 'Filters',
      bookmakers: 'Bookmakers',
      selectAll: 'Select all',
      deselectAll: 'Deselect all',
      apply: 'Apply filters',
      activeCount: 'Active filters: {count}',
    },
    marginTypes: {
      margin1X2: 'Match Result',
      marginOverUnder2AndHalf: 'Over/Under 2.5 Goals',
      marginBothScore: 'Both Teams to Score',
      marginDoubleChance: 'Double Chance',
      margin1Xvs2: '1X vs 2',
      marginX2vs1: 'X2 vs 1',
      margin12vsX: '12 vs X',
      marginOverUnder1AndHalf: 'Over/Under 1.5 Goals',
      marginOverUnder3AndHalf: 'Over/Under 3.5 Goals',
    },
    outcomes: {
      Coef1: 'Home Win',
      CoefX: 'Draw',
      Coef2: 'Away Win',
      CoefGoalOver2AndHalf: 'Over 2.5',
      CoefGoalUnder2AndHalf: 'Under 2.5',
      CoefBothScoreYes: 'Yes',
      CoefBothScoreNo: 'No',
      Coef1X: 'Home Win or Draw',
      CoefX2: 'Draw or Away Win',
      Coef12: 'Home Win or Away Win',
      CoefYesGoal: 'Goal',
      CoefNoGoal: 'No Goal',
      CoefGoalOver1AndHalf: 'Over 1.5',
      CoefGoalUnder1AndHalf: 'Under 1.5',
      CoefGoalOver3AndHalf: 'Over 3.5',
      CoefGoalUnder3AndHalf: 'Under 3.5',
    },
    bookmakers: {
      betano: 'Betano',
      bet365: 'Bet365',
      winbet: 'Winbet',
      betwild: 'Betwild',
      slybet: 'Slybet',
      bwin: 'Bwin',
      efbet: 'Efbet',
      inbet: 'Inbet',
      alphawin: 'Alphawin',
      sesame: 'Sesame',
      elitbet: 'Elitbet',
      bethub: 'Bethub',
      bet: 'Bet.bg',
      topwin: 'Topwin',
      mrbit: 'MrBit',
      admiralbet: 'Admiralbet',
      bg8888: '8888.bg',
      palmsbet: 'Palmsbet',
      everbet: 'Everbet',
      magicbet: 'Magicbet',
      betvam: 'Betvam',
      qbet: 'Qbet',
      imperiabet: 'Imperiabet',
    },
    calculator: {
      title: 'Arbitrage Calculator',
      modalTitle: 'Arbitrage Calculator',
      modalTitleWithEvent: 'Calculator for {teamOne} vs {teamTwo}',
      modalSubtitle: 'Calculate optimal stake distribution for expected return',
      modalSubtitleWithEvent: '{championship} • {date} {time}',
      modalInfo: 'Data pre-populated from the selected arbitrage opportunity',
      closeModal: 'Close calculator',
      close: 'Close',
      totalStake: 'Total budget for allocation',
      totalStakePlaceholder: 'Enter total budget',
      distribution: 'Optimal allocation',
      guaranteedProfit: 'Expected return (ROI)',
      profitPercentage: 'Profit Percentage',
      bookmaker: 'Bookmaker',
      outcome: 'Outcome',
      coefficient: 'Coefficient',
      stake: 'Stake',
      profit: 'Profit',
      calculate: 'Calculate',
      reset: 'Reset',
      copyStakes: 'Copy Stakes',
      stakescopied: 'Stakes copied to clipboard',
      minStakeWarning: 'Minimum stake: {amount} BGN',
      invalidStake: 'Invalid stake amount',
      eventDetails: 'Event Details',
      marketType: 'Market Type',
      market2Way: '2-way market',
      market3Way: '3-way market',
      market2WayDetailed: '2-way (e.g. Both Teams to Score, Over/Under)',
      market3WayDetailed: '3-way (1X2 Match Result)',
      enterTotalStake: 'Enter total budget for allocation',
      calculatedStakes: 'Optimal allocation',
      stakeFor: 'Amount for position',
      positionProfit: 'Expected return (position "{outcome}"): {amount} EUR',
      overallRoi: 'Overall expected return (ROI)',
      expectedResult: 'Expected result',
      stakeFieldReadOnlyHint: 'Click to fix this position amount',
      stakeFieldEditableHint: 'Fixed position — other amounts recalculate automatically',
      stakeFieldAnchoredHint: 'Manual position — total budget is locked',
      stakeFieldDerivedHint: 'Derived position — calculated from locked total budget',
      stakeFieldPromoteHint: 'Click to set this position manually',
      totalBudgetLockedHint: 'Total budget is locked while manual positions are set',
      // Outcome labels
      outcome1: 'Home Win',
      outcomeX: 'Draw',
      outcome2: 'Away Win',
      outcomeOver25: 'Over 2.5',
      outcomeUnder25: 'Under 2.5',
      outcomeBothScoreYes: 'Both Teams to Score',
      outcomeBothScoreNo: 'Both Teams Not to Score',
      outcome1X: '1X',
      outcomeX2: 'X2',
      outcome12: '12',
      outcomeYesGoal: 'Goal',
      outcomeNoGoal: 'No Goal',
      outcomeOver15: 'Over 1.5',
      outcomeUnder15: 'Under 1.5',
      outcomeOver35: 'Over 3.5',
      outcomeUnder35: 'Under 3.5',
    },
  },

  notifications: {
    unread: {
      one: 'You have {count} unread notification',
      other: 'You have {count} unread notifications',
    },
    copied: 'Copied to clipboard',
  },

  accessibility: {
    skipToContent: 'Skip to content',
    openMenu: 'Open menu',
    closeMenu: 'Close menu',
    header: 'Header',
    footer: 'Footer',
    main: 'Main content',
  },

  surebets: {
    list: {
      ariaLabel: 'List of arbitrage opportunities',
      title: 'Arbitrage opportunities',
      total: 'Total',
      profitable: 'Profitable',
      refreshButton: 'Refresh',
      lastUpdate: 'Last update',
      loading: 'Loading arbitrages...',
      refreshing: 'Refreshing...',
      justNow: 'Just now',
      oneMinuteAgo: '1 minute ago',
      minutesAgo: '{minutes} minutes ago',
      neverRefreshed: 'Never',
      noData: 'No arbitrages available',
      noDataTitle: 'No Arbitrage Opportunities Found',
      noDataDescription: 'There are currently no arbitrage opportunities available. Try again later or adjust your filters.',
      errorTitle: 'Loading Error',
      errorDescription: 'An error occurred while loading arbitrage opportunities.',
      retryButton: 'Try Again',
      errorHelp: 'If the problem persists, please contact support.',
      tips: 'Tips:',
      tip1: 'Check for new opportunities periodically',
      tip2: 'Use the operator filters to personalize results',
      tip3: 'Quick reaction is key for arbitrage opportunities',
    },
    refresh: {
      refresh: 'Refresh',
      refreshing: 'Refreshing...',
      refreshButton: 'Refresh Data',
      lastUpdate: 'Last update',
      nextRefresh: 'Next refresh',
      justNow: 'Just now',
      secondsAgo: '{seconds} seconds ago',
      oneMinuteAgo: '1 minute ago',
      minutesAgo: '{minutes} minutes ago',
      neverRefreshed: 'Never',
      pause: 'Pause',
      resume: 'Resume',
      paused: 'Paused',
      pausedMessage: 'Auto-refresh is paused',
      autoRefresh: 'Auto-refresh',
      autoRefreshOn: 'Auto-refresh enabled',
      autoRefreshOff: 'Auto-refresh disabled',
      offline: 'Offline',
      offlineWarning: 'No internet connection',
      rateLimitExceeded: 'Too many refresh attempts',
    },
    card: {
      ariaLabel: 'Arbitrage opportunity',
      vs: 'vs',
      market: 'Market',
      bookmakerOdds: 'Operator and coefficient',
      profit: 'Margin',
      actions: 'Actions',
      calculatorButton: 'Calculator',
      noMarginData: 'No margin data',
      noCoefficients: 'No coefficients',
    },
    marginTypes: {
      margin1X2: 'Match Result (1X2)',
      marginOverUnder2AndHalf: 'Over/Under 2.5 Goals',
      marginBothScore: 'Both Teams to Score',
      marginDoubleChance: 'Double Chance',
      margin1Xvs2: '1X vs 2',
      marginX2vs1: 'X2 vs 1',
      margin12vsX: '12 vs X',
      marginOverUnder1AndHalf: 'Over/Under 1.5 Goals',
      marginOverUnder3AndHalf: 'Over/Under 3.5 Goals',
    },
    outcomes: {
      Coef1: '1',
      CoefX: 'X',
      Coef2: '2',
      CoefGoalOver2AndHalf: 'Over 2.5',
      CoefGoalUnder2AndHalf: 'Under 2.5',
      CoefBothScoreYes: 'Yes',
      CoefBothScoreNo: 'No',
      Coef1X: 'Home Win or Draw',
      CoefX2: 'Draw or Away Win',
      Coef12: 'Home Win or Away Win',
      CoefYesGoal: 'Goal',
      CoefNoGoal: 'No Goal',
      CoefGoalOver1AndHalf: 'Over 1.5',
      CoefGoalUnder1AndHalf: 'Under 1.5',
      CoefGoalOver3AndHalf: 'Over 3.5',
      CoefGoalUnder3AndHalf: 'Under 3.5',
    },
    calculator: {
      title: 'Arbitrage Calculator',
      modalTitle: 'Arbitrage Calculator',
      modalTitleWithEvent: 'Calculator for {teamOne} vs {teamTwo}',
      modalSubtitle: 'Calculate optimal stake distribution for expected return',
      modalSubtitleWithEvent: '{championship} • {date} {time}',
      modalInfo: 'Data pre-populated from the selected arbitrage opportunity',
      closeModal: 'Close calculator',
      close: 'Close',
      totalStake: 'Total budget for allocation',
      totalStakePlaceholder: 'Enter total budget',
      distribution: 'Optimal allocation',
      guaranteedProfit: 'Expected return (ROI)',
      profitPercentage: 'Profit Percentage',
      bookmaker: 'Bookmaker',
      outcome: 'Outcome',
      coefficient: 'Coefficient',
      stake: 'Stake',
      profit: 'Profit',
      calculate: 'Calculate',
      calculating: 'Calculating...',
      reset: 'Reset',
      copyStakes: 'Copy Stakes',
      stakescopied: 'Stakes copied to clipboard',
      minStakeWarning: 'Minimum stake: {amount} BGN',
      invalidStake: 'Invalid stake amount',
      eventDetails: 'Event Details',
      marketType: 'Market Type',
      market2Way: '2-way market',
      market3Way: '3-way market',
      market2WayDetailed: '2-way (e.g. Both Teams to Score, Over/Under)',
      market3WayDetailed: '3-way (1X2 Match Result)',
      enterTotalStake: 'Enter total budget for allocation',
      calculatedStakes: 'Optimal allocation',
      stakeFor: 'Amount for position',
      positionProfit: 'Expected return (position "{outcome}"): {amount} EUR',
      overallRoi: 'Overall expected return (ROI)',
      expectedResult: 'Expected result',
      stakeFieldReadOnlyHint: 'Click to fix this position amount',
      stakeFieldEditableHint: 'Fixed position — other amounts recalculate automatically',
      stakeFieldAnchoredHint: 'Manual position — total budget is locked',
      stakeFieldDerivedHint: 'Derived position — calculated from locked total budget',
      stakeFieldPromoteHint: 'Click to set this position manually',
      totalBudgetLockedHint: 'Total budget is locked while manual positions are set',
      outcome1: 'Home Win',
      outcomeX: 'Draw',
      outcome2: 'Away Win',
      outcomeOver25: 'Over 2.5',
      outcomeUnder25: 'Under 2.5',
      outcomeBothScoreYes: 'Both Teams to Score',
      outcomeBothScoreNo: 'Both Teams Not to Score',
      outcome1X: '1X',
      outcomeX2: 'X2',
      outcome12: '12',
      outcomeYesGoal: 'Goal',
      outcomeNoGoal: 'No Goal',
      outcomeOver15: 'Over 1.5',
      outcomeUnder15: 'Under 1.5',
      outcomeOver35: 'Over 3.5',
      outcomeUnder35: 'Under 3.5',
    },
    viewFilters: {
      shownCount: 'Showing {filtered} of {total}',
      searchPlaceholder: 'Search team or championship...',
      searchAriaLabel: 'Search by team or championship',
      searchClear: 'Clear search',
      searchClearAriaLabel: 'Clear the search field',
      marginLabel: 'Minimum deviation',
      marginAll: 'All',
      marginChip: '≥ {value}%',
      marginChipAriaLabel: 'Filter arbitrages with margin of at least {value}%',
      marginAllAriaLabel: 'Show all arbitrages without a margin filter',
      panelToggleShow: 'Show filters',
      panelToggleHide: 'Hide filters',
      panelAriaLabel: 'Additional filters for arbitrage opportunities',
      championshipsLabel: 'Championships',
      championshipsSelectAll: 'Select all',
      championshipsDeselectAll: 'Deselect all',
      championshipsSearchPlaceholder: 'Search championship...',
      championshipsAriaLabel: 'Filter by championship',
      championshipsNone: 'Championships: 0',
      marketsLabel: 'Market type',
      marketsSelectAll: 'Select all',
      marketsDeselectAll: 'Deselect all',
      marketsAriaLabel: 'Filter by market type',
      marketsNone: 'Markets: 0',
      timeWindowLabel: 'Time window',
      timeWindowAll: 'All',
      timeWindowToday: 'Today',
      timeWindowNext24h: 'Next 24h',
      timeWindowNext48h: 'Next 48 hours',
      timeWindowAriaLabel: 'Filter by kick-off time',
      timeWindowAllAriaLabel: 'Show arbitrages without a time filter',
      activeFilters: 'Active filters',
      clearAll: 'Clear all',
      clearAllAriaLabel: 'Clear all arbitrage list filters',
      clearFilters: 'Clear filters',
      removeFilterAriaLabel: 'Remove filter {name}',
      emptyFilteredTitle: 'No results with these filters',
      emptyFilteredDescription: 'Try broader criteria or clear the active filters.',
    },
  },
  bestOdds: {
    radar: {
      title: 'Best Odds Radar',
      total: 'Active anomalies',
      topSpread: 'Highest deviation',
      refreshButton: 'Refresh',
      lastUpdate: 'Last update',
      refreshing: 'Refreshing...',
      justNow: 'Just now',
      oneMinuteAgo: '1 minute ago',
      minutesAgo: '{minutes} minutes ago',
      neverRefreshed: 'Never',
      ariaLabel: 'Best Odds alerts list',
      loading: 'Loading Best Odds alerts...',
      noDataTitle: 'No anomalies detected',
      noDataDescription: 'No market anomalies detected in Tier 1 leagues right now. Please check back later.',
      errorTitle: 'Error loading data',
      errorDescription: 'An error occurred while loading Best Odds alerts.',
      retryButton: 'Try again',
    },
    card: {
      ariaLabel: 'Best Odds alert',
      newBestOddsBadge: 'NEW BEST ODDS',
      marketAvgLabel: 'Market average',
      spreadLabel: 'Deviation',
      bookmakerCountLabel: 'Bookmakers',
      viewButton: 'View',
    },
    modal: {
      title: 'Market Anomaly Details',
      eventDetails: 'Event Details',
      marketType: 'Market Type',
      bestOddsLabel: 'Best odds',
      marketAvgLabel: 'Market average',
      spreadLabel: 'Deviation',
      bookmakerCountLabel: 'Bookmaker count',
      oddsLadderTitle: 'All Odds',
      oddsLadderBookmaker: 'Bookmaker',
      oddsLadderOdds: 'Odds',
      close: 'Close',
    },
    filters: {
      searchPlaceholder: 'Search team or championship...',
      searchAriaLabel: 'Search by team or championship',
      searchClear: 'Clear search',
      searchClearAriaLabel: 'Clear the search field',
      spreadLabel: 'Minimum deviation',
      spreadAll: 'All',
      spreadChip: '≥ {value}%',
      spreadChipAriaLabel: 'Filter anomalies with deviation of at least {value}%',
      spreadAllAriaLabel: 'Show all anomalies without a deviation filter',
      maxOddsLabel: 'Maximum odds',
      maxOddsAll: 'All',
      maxOddsChip: '≤ {value}',
      maxOddsChipAriaLabel: 'Filter anomalies with odds of at most {value}',
      maxOddsAllAriaLabel: 'Show all anomalies without a maximum odds filter',
      bookmakersLabel: 'Bookmakers',
      bookmakersSelectAll: 'Select all',
      bookmakersDeselectAll: 'Deselect all',
      bookmakersSearchPlaceholder: 'Search bookmaker...',
      bookmakersAriaLabel: 'Filter by bookmaker with the best odds',
      shownCount: 'Showing {filtered} of {total}',
      activeFilters: 'Active filters',
      clearFilters: 'Clear filters',
      clearAll: 'Clear all',
      clearAllAriaLabel: 'Clear all market anomaly filters',
      removeFilterAriaLabel: 'Remove filter {name}',
      emptyFilteredTitle: 'No results with these filters',
      emptyFilteredDescription: 'Try broader criteria or clear the active filters.',
      // v1.1
      panelToggle: 'Filters',
      panelToggleShow: 'Show filters',
      panelToggleHide: 'Hide filters',
      panelAriaLabel: 'Additional market anomaly filters',
      championshipsLabel: 'Championships',
      championshipsSelectAll: 'Select all',
      championshipsDeselectAll: 'Deselect all',
      championshipsSearchPlaceholder: 'Search championship...',
      championshipsAriaLabel: 'Filter by championship',
      championshipsNone: 'Championships: 0',
      marketsLabel: 'Market type',
      marketsSelectAll: 'Select all',
      marketsDeselectAll: 'Deselect all',
      marketsAriaLabel: 'Filter by market type',
      marketsNone: 'Markets: 0',
      timeWindowLabel: 'Time window',
      timeWindowAll: 'All',
      timeWindowToday: 'Today',
      timeWindowNext24h: 'Next 24h',
      timeWindowNext48h: 'Next 48 hours',
      timeWindowAriaLabel: 'Filter by kick-off time',
      timeWindowAllAriaLabel: 'Show anomalies without a time filter',
    },
  },
};

export default en;


